<!--
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2022-12-15 20:57:58
 * @Description: 左侧菜单导航
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved. 
-->
<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu mode="vertical" class="apiview" :show-timeout="200" :default-active="$route.path" :collapse="isCollapse"
      router popper-class="trueD" :background-color="themeStatus ? 'var(--background-color) !important' : ''">

      <sidebar-item v-for="route in routes" :key="route.path.replaceAll('/', '_')" :item="route"
        :base-path="route.path"></sidebar-item>


    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import EventBus from "@/utils/EventBus";
export default {
  components: { SidebarItem },
  data() {
    return {
      routes: []
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'permission_routers', 'themeStatus']),
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    let boj = JSON.parse(window.localStorage.getItem('routers'));

    this.$nextTick(() => {
      boj.length > 0 && boj.forEach(item => {
        if (item.name === 'layout') {
          this.routes = item.children.sort((a, b) => a.meta.sortNo - b.meta.sortNo)
        }
      })
    })
  },
  mounted() {
    EventBus.$on("Cdchage", (row) => {
      this.filterRoutes(row)
    });
  },
  beforeDestroy() {
    EventBus.$off("Cdchage")
  },
  methods: {
    filterRoutes(row) {
      if (row == '') {
        let boj = JSON.parse(window.localStorage.getItem('routers'));
        this.$nextTick(() => {
          boj.length > 0 && boj.forEach(item => {
            if (item.name === 'layout') {
              this.routes = item.children.sort((a, b) => a.meta.sortNo - b.meta.sortNo)
              this.oo = this.routes
            }
          })
        })
      } else {
        let boj = JSON.parse(window.localStorage.getItem('routers'));

        this.$nextTick(() => {
          boj.length > 0 && boj.forEach(item => {
            if (item.name === 'layout') {
              let xo = item.children.sort((a, b) => a.meta.sortNo - b.meta.sortNo)
              let Px = []
              let MM = []
              xo.forEach(x => {
                if (x.name && x.name.indexOf(row) != -1) {
                  Px.push(x)
                } else {
                  if (x.children) {
                    x.children.forEach(y => {
                      if (y.name && y.name.indexOf(row) != -1) {
                        MM.push(y)
                        x.children = MM
                        Px.push(x)
                      }
                    })
                  }
                }
              })

              const result = this.removeDuplicate(Px)
              this.routes = result

            }
          })
        })
      }
    },
    removeDuplicate(arr) {
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].id == arr[j].id) {
            arr.splice(j, 1);
            j--;
          }
        }
      }
      return arr
    }
  }

}
</script>
<style scoped lang="less">
.body {

  top: 0;
  right: 0;
  overflow-y: auto;
}

.trueD .el-menu {
  // margin-left: -5px  !important;
  // margin-top: -10px;
  // position: absolute;
  // top: 0;
  // right: 0;
  overflow-y: auto;
  height: 200px !important;
}

.apiview:deep(.el-menu-item.is-active) {

  background-image: linear-gradient(300deg, rgb(238, 240, 255) 80%, var(--primary-color) 100%);
  // opacity: 0.5;
  // background-color: rgb(238, 240, 255) !important;
  color: var(--text-color) !important;

  // color:#000!important;
}
</style>
